import { useTranslation } from 'react-i18next';

import { TransfersSearchForm } from '@frontend/features/travel-services/components/TransfersSearchForm';
import { TravelServicesPage } from '@frontend/features/travel-services/components/TravelServicesPage';
import { useSearchFormKey } from '@frontend/features/travel-services/useSearchUrlState';

/** Buscador de traslados (vertical transfers de Rutero). */
export const Transfers = () => {
  const { t } = useTranslation();
  // Aplicar una búsqueda reciente remonta el buscador: si no, los campos
  // (que se llenan al montar) quedarían vacíos bajo los resultados nuevos.
  const formKey = useSearchFormKey();

  return (
    <TravelServicesPage
      title={t('common.nav.transfers')}
      intro={t('travelServices.transfersIntro')}
    >
      <TransfersSearchForm key={formKey} />
    </TravelServicesPage>
  );
};

export default Transfers;
